module.exports = __webpack_public_path__ + "static/media/trainers-background-side.58c1b086.png";